export default __webpack_public_path__ + "static/media/hedge.cf28a239.png";